import { RegisterFormValues, RegisterPayload } from '../../types';
import { endpoints } from '../endpoints';
import { ApiResponseErrorShape } from 'types/api-response';
import { captureException } from '@sentry/browser';
import { trans } from '@pepita-i18n/babelfish';

const GENERIC_ERROR_LABEL = 'agency.register.error.GENERIC';
export const postRegisterApi = async (formData: RegisterFormValues) => {
    var csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content');

    if (csrfToken) {
        const response = await fetch(endpoints.AUTH_REGISTER_CREATE, {
            method: 'POST',
            body: JSON.stringify({
                ...formData,
                prefisso: formData.prefisso?.callingCode,
            } as RegisterPayload),
            headers: {
                'Content-Type': 'application/json',
                'anti-csrf-token': csrfToken,
            },
        });

        if (!response.ok) {
            let responseJson: ApiResponseErrorShape<{ message: string }>;
            try {
                responseJson = await response.json();
            } catch (err) {
                const errorText = 'Failed to parse response json';
                console.error(errorText);
                captureException(errorText);
                throw new Error(trans(GENERIC_ERROR_LABEL));
            }

            throw Error(responseJson.data?.message || '');
        }
    } else {
        const errorText = 'Csrf token not found';
        console.error(errorText);
        captureException(errorText);
        throw new Error(trans(GENERIC_ERROR_LABEL));
    }

    return;
};
